import type { FC } from 'react'
import styled from 'styled-components'

import H6 from '@/components/H6'
import TextInput from '@/components/TextInput'
import type { AdverseCredit as Fields } from '@/types/adverseCredit'

import DeclarationSelect from './DeclarationSelect'
import RemoveButton from './RemoveButton'
import StateSelect from './StateSelect'

const Container = styled.div`
  display: grid;
  gap: 10px;
`

const HeaderContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr min-content;
`

const SelectOptionsRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
`

const CourtDetailsContainer = styled.div`
  margin-top: 10px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  align-items: center;
  gap: 20px;
`

interface Props {
  values: Fields
  onChangeValues: (fields: Fields) => void
  onRemove: () => void
  disableEditing?: boolean
}

const AdverseCreditFields: FC<Props> = ({
  values,
  onChangeValues,
  onRemove,
  disableEditing,
}) => (
  <Container>
    <HeaderContainer>
      <div>
        <H6>Adverse credit: {values.caseNumber}</H6>
      </div>
      <div>
        <RemoveButton onRemove={onRemove} />
      </div>
    </HeaderContainer>
    <div>
      <SelectOptionsRow>
        <div>
          <DeclarationSelect
            selectedValue={values.declaration}
            onSelect={declaration =>
              onChangeValues({
                ...values,
                declaration,
              })
            }
            disabled={disableEditing}
          />
        </div>
        <div>
          <StateSelect
            selectedValue={values.state}
            onSelect={state =>
              onChangeValues({
                ...values,
                state,
              })
            }
            disabled={disableEditing}
          />
        </div>
      </SelectOptionsRow>
    </div>
    <div>
      <CourtDetailsContainer>
        <div>
          <TextInput
            label="Court date"
            name="courtDate"
            type="date"
            value={values.courtDate}
            onChange={courtDate => onChangeValues({ ...values, courtDate })}
            disabled={disableEditing}
          />
        </div>
        <div>
          <TextInput
            value={values.caseNumber}
            label="Case number"
            name="caseNumber"
            onChange={caseNumber =>
              onChangeValues({
                ...values,
                caseNumber,
              })
            }
            disabled={disableEditing}
          />
        </div>
        <div>
          <TextInput
            type="number"
            value={values.amount}
            label="Amount"
            name="amount"
            onChange={amount =>
              onChangeValues({
                ...values,
                amount: parseInt(amount),
              })
            }
            disabled={disableEditing}
          />
        </div>
      </CourtDetailsContainer>
    </div>
  </Container>
)

export default AdverseCreditFields
